import dayjs from 'dayjs';

/**
 * Formats the store's nearest delivery interval label. Prefers the structured
 * `nearestDelivery` (title + interval + price), falling back to the
 * `nearestAvailableInterval` date.
 */
export const formatNearestInterval = (store: any): string => {
  let nearestInterval = dayjs(store?.nearestAvailableInterval?.value).format(
    'D MMMM'
  );

  const titleDay = store?.nearestDelivery?.title;
  const intervalDay = store?.nearestDelivery?.interval
    ?.split('-')
    .join(' до ');
  const price = store?.nearestDelivery?.price;

  if (titleDay && intervalDay) {
    nearestInterval = `${titleDay} ${intervalDay}, ${price || 'бесплатно'}`;
  }

  return nearestInterval;
};
